import { TripSummary } from "./trip-summary";
import { AddOns } from "./add-ons";
import { Container, SectionsWrapper, Section } from "./styles";
import { WhatsCovered } from "./whats-covered";
import { useBreakpoint } from "hooks/use-breakpoint";
import { TripInfoSection } from "./trip-summary/trip-info";
import { getFeatureVariation } from "utils/features";

export function OfferBCBody() {
  const mdBreakpoint = useBreakpoint("md");
  const offerPageExperiment = getFeatureVariation("offerPageExperiment");
  const addOnDialogExp = offerPageExperiment === "addons_in_popup";

  return (
    <Container>
      {!mdBreakpoint && <TripInfoSection />}
      <SectionsWrapper>
        <Section>
          <WhatsCovered />
        </Section>
        {mdBreakpoint && (
          <Section>
            <TripSummary />
            {!addOnDialogExp && <AddOns coloredSection />}
          </Section>
        )}
      </SectionsWrapper>
    </Container>
  );
}
